import { apiClient as api } from "./httpClient";

// Canais de WhatsApp da entidade (números na Meta Cloud API).
// O token NUNCA passa pelo front: o canal guarda só o NOME da env que o contém.

export interface WhatsAppChannel {
  id: string;
  name: string;
  phoneNumberId: string;
  wabaId: string | null;
  displayPhone: string | null;
  defaultPipelineId: string | null;
  agentId: string | null;
  tokenEnvVar: string | null;
  active: boolean;
}

export interface ChannelPayload {
  name: string;
  wabaId: string | null;
  displayPhone: string | null;
  defaultPipelineId: string | null;
  tokenEnvVar: string | null;
}

export interface CreateChannelPayload extends ChannelPayload {
  entityId: string;
  phoneNumberId: string;
}

export interface CreatedId {
  id: string;
}

export const whatsappChannelsService = {
  getByEntity: async (entityId: string, includeInactive = false): Promise<WhatsAppChannel[]> => {
    const response = await api.get(`/integrations/whatsapp/channels/by-entity/${entityId}`, {
      params: { includeInactive },
    });
    return Array.isArray(response.data) ? response.data : [];
  },

  create: async (payload: CreateChannelPayload): Promise<CreatedId> => {
    const response = await api.post("/integrations/whatsapp/channels", payload);
    return response.data;
  },

  update: async (channelId: string, entityId: string, payload: ChannelPayload): Promise<void> => {
    await api.put(`/integrations/whatsapp/channels/${channelId}`, { entityId, ...payload });
  },

  setActive: async (channelId: string, entityId: string, active: boolean): Promise<void> => {
    await api.post(`/integrations/whatsapp/channels/${channelId}/active`, { entityId, active });
  },
};
